import React from 'react';
import { observer } from 'mobx-react';
import { RouterState, routerStateToUrl } from 'mobx-state-router';

const ORDER_DETAIL_ROUTE = 'master.app.main.order.list.detail';

function getOrderDetailUrl(routerStore, id) {
	const toState = new RouterState(ORDER_DETAIL_ROUTE, { id });
	return routerStateToUrl(routerStore, toState);
}

const STATUS_STYLES = {
	Entered: { background: '#e8f0fb', color: '#2a6db5' },
	Assigned: { background: '#fff4e0', color: '#c97a00' },
	Picking: { background: '#e8f7f4', color: '#1da88d' },
	'Exit Scan': { background: '#f1ecfb', color: '#6b4ec7' },
	'Shipped Externally': { background: '#f1ecfb', color: '#993117' },
};

const LTL_STYLE = { background: '#fdf0e6', color: '#b45309' };
const PARCEL_STYLE = { background: '#eef1f5', color: '#5b6b7d' };

function formatDate(val) {
	if (!val) return '—';
	const s = String(val).slice(0, 10);
	const d = new Date(s + 'T00:00:00');
	return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
}

function Check() {
	return (
		<svg
			width="14"
			height="14"
			viewBox="0 0 24 24"
			fill="none"
			stroke="#2ec4a5"
			strokeWidth="2.5"
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M20 6L9 17l-5-5" />
		</svg>
	);
}

const GridViewModal = observer(({ viewStore }) => {
	const { gridOrders, gridLoading, gridError, showWarehouses, showSellers } = viewStore;
	const showSeller = showSellers;
	const showWarehouse = showWarehouses;

	const onOverlayClick = () => viewStore.closeGridView();
	const stopPropagation = e => e.stopPropagation();

	return (
		<div className="modal-overlay" onClick={onOverlayClick}>
			<div className="modal modal--wide" onClick={stopPropagation}>
				<div className="modal__header">
					<span className="modal__title">
						Orders {!gridLoading && !gridError && `(${gridOrders.length.toLocaleString()})`}
					</span>
					<div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
						{!gridLoading && !gridError && gridOrders.length > 0 && (
							<button
								className="modal__export-btn"
								onClick={() => viewStore.exportGridToCsv({ showSeller, showWarehouse })}
							>
								Export CSV
							</button>
						)}
						<button className="modal__close" onClick={() => viewStore.closeGridView()}>
							{'✕'}
						</button>
					</div>
				</div>

				{gridLoading && <div className="chart-card__loading">Loading...</div>}

				{gridError && <p className="chart-card__error">{gridError}</p>}

				{!gridLoading && !gridError && (
					<div className="grid-view-wrap">
						<table className="grid-view-table">
							<thead>
								<tr>
									<th>Order #</th>
									{showSeller && <th>Seller</th>}
									{showWarehouse && <th>Warehouse</th>}
									<th>Status</th>
									<th>Channel</th>
									<th>Type</th>
									<th>Ship By</th>
									<th style={{ textAlign: 'center' }}>On Hold</th>
									<th style={{ textAlign: 'center' }}>Prime</th>
								</tr>
							</thead>
							<tbody>
								{gridOrders.map(o => (
									<tr key={o.fulfillmentOrderId}>
										<td className="grid-view-table__id">
											{o.id ? (
												<a
													className="grid-view-table__link"
													href={getOrderDetailUrl(viewStore.rootStore.routerStore, o.id)}
													target="_blank"
													rel="noopener noreferrer"
												>
													{o.fulfillmentOrderId}
												</a>
											) : (
												o.fulfillmentOrderId
											)}
										</td>
										{showSeller && <td>{o.sellerName}</td>}
										{showWarehouse && <td>{o.warehouseName ? o.warehouseName : '—'}</td>}
										<td style={{ whiteSpace: 'nowrap' }}>
											<span className="grid-view-badge" style={STATUS_STYLES[o.status] ? STATUS_STYLES[o.status] : {}}>
												{o.status}
											</span>
										</td>
										<td>{o.channel ? o.channel : '—'}</td>
										<td>
											<span className="grid-view-badge" style={o.isLtl ? LTL_STYLE : PARCEL_STYLE}>
												{o.isLtl ? 'LTL' : 'Parcel'}
											</span>
										</td>
										<td style={{ whiteSpace: 'nowrap' }}>{formatDate(o.shipByDate)}</td>
										<td style={{ textAlign: 'center' }}>{o.isOnHold ? <Check /> : ''}</td>
										<td style={{ textAlign: 'center' }}>{o.isPrime ? <Check /> : ''}</td>
									</tr>
								))}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</div>
	);
});

export default GridViewModal;
